import $router from "@/router/index.js"
import $H from "@/utils/request.js"
export default {
	state: {
		menuType: 'left',
		leftMenuList: [],
		topMenuList: [],
		topMenuActive: 0,
		isLoadRoute: false,
		activeTabValue: '/index',
		userInfo: {},
		tabList: [ {title: '首页', name: '/index'}],
		menuList: [],
		schoolList: [],
		nowSchoolId: null,
		awaitFeedbackNum: 0,
		awaitStudentAuthNum1: 0,
		awaitStudentAuthNum2: 0,
		awaitTravelRefundOrderNum: 0,
		awaitDriverCustomer: 0,
		awaitSchoolCardNum: 0,
		awaitGoodsOrderNum:0
	},
	getters: {
		nowSchool(state) {
			if(state.nowSchoolId){
				let school = state.schoolList.find(v => v.id == state.nowSchoolId)
				return school
			}else return null
		}
	},
	mutations: {
		chooseSchool(state, schoolId){
			sessionStorage.setItem('nowSchoolId', schoolId)
			state.nowSchoolId = schoolId
		},
		initInfo(state) {
			let menuType = localStorage.getItem("menuType")
			if(menuType) state.menuType = menuType
			let userInfo = localStorage.getItem("userInfo")
			if(userInfo) state.userInfo = JSON.parse(userInfo)
			let tabList = sessionStorage.getItem("tabList")
			if(tabList) state.tabList = JSON.parse(tabList)
			let menuList = sessionStorage.getItem("menuList")
			if(menuList) state.menuList = JSON.parse(menuList)
			let nowSchoolId = sessionStorage.getItem("nowSchoolId")
			if(nowSchoolId) state.nowSchoolId = parseInt(sessionStorage.getItem("nowSchoolId"))
		},
		setIsLoadRoute(state){
			state.isLoadRoute = true
		},
		addTab(state, tab){
			if(tab.openType && tab.openType != 1) return
			if(tab.meta && tab.meta.openType && tab.meta.openType != 1) return
			let tabList = sessionStorage.getItem('tabList')
			if(tabList == null) tabList = [ {title: '首页', name: '/index'}]
			else tabList = JSON.parse(tabList)
			let path = decodeURI(tab.path)
			let index = tabList.findIndex(v => v.name == path)
			if(index == -1){
				let title = tab.name
				if(tab.meta && tab.meta.name) title = tab.meta.name
				tabList.push({title: title, name: path})
				sessionStorage.setItem('tabList', JSON.stringify(tabList))
				state.tabList = tabList
			}
			state.activeTabValue = path
			if(state.menuType == 'top') {
				setTimeout(()=>{
					let index = selectNowActive(state.topMenuList,state.activeTabValue)
					if(index > -1 && state.topMenuActive != index) {
						state.topMenuActive = index
						this.commit('initLeftMenu')
					}
				},1)
			}
		},
		removeTab(state,tabName){
			let tabList = sessionStorage.getItem('tabList')
			if(tabList == null) tabList = [ {title: '首页', name: '/index'}]
			else tabList = JSON.parse(tabList)
			let index = tabList.findIndex(v => v.name == tabName)
			tabList.splice(index, 1)
			sessionStorage.setItem('tabList', JSON.stringify(tabList))
			state.tabList = tabList
			let path = decodeURI($router.currentRoute.path)
			if(path == tabName) $router.push(state.tabList[index - 1].name)
			if(state.menuType == 'top') {
				setTimeout(()=>{
					let index = selectNowActive(state.topMenuList,state.activeTabValue)
					if(index > -1 && state.topMenuActive != index) {
						state.topMenuActive = index
						this.commit('initLeftMenu')
					}
				},1)
			}
			
		},
		clearLoginInfo(state){
			state.isLoadRoute = false,
			state.userInfo = {}
			state.activeTabValue = '/index',
			state.tabList = [ {title: '首页', name: '/index'}]
			state.menuList = []
			state.nowSchoolId = null
			localStorage.removeItem("userInfo")
			localStorage.removeItem("token")
			localStorage.removeItem("nowSchoolId")
			sessionStorage.clear()
		},
		initTopMenu(state){
			if(state.menuType == 'left') state.topMenuList = []
			else{
				state.topMenuList = state.menuList.slice(1)
				let index = selectNowActive(state.topMenuList,state.activeTabValue)
				state.topMenuActive = index > -1 ? index : 0
			} 
		},
		initLeftMenu(state){
			state.leftMenuList = []
			setTimeout(()=>{
				if(state.menuType == 'left') state.leftMenuList = state.menuList
				else{
					let nowMenuList = state.topMenuList[state.topMenuActive].children
					state.leftMenuList = nowMenuList ? nowMenuList : []
				}
			},1)
		},
		clickTopMenu(state, {index,item}){
			state.topMenuActive = index
			this.commit('initLeftMenu')
			if(item.type == 2) $router.push(item.path)
		},
		changeMenuType(state){
			if(state.menuType == 'left') state.menuType = 'top'
			else state.menuType = 'left'
			localStorage.setItem("menuType", state.menuType)
			this.commit('initTopMenu')
			this.commit('initLeftMenu')
		}
	},
	actions: {
		async getUserInfo({ state }) {
			let userInfo = await $H.get("/admin/fwUser/getUserInfo")
			state.userInfo = userInfo
			localStorage.setItem("userInfo", JSON.stringify(userInfo))
		},
		async getMenuList({state,commit,dispatch}) {
			let menuList = await $H.get("/admin/fwMenu/getMyMenuList")
			state.menuList = menuList
			menuList.unshift({
					name: '首页',
					icon: 'el-icon-s-home',
					path: '/index',
					componentType: 1,
					component: '/index/index',
					type: 2
				})	
			sessionStorage.setItem("menuList", JSON.stringify(menuList))
			state.isLoadRoute = false
			commit("initTopMenu")
			commit("initLeftMenu")
			dispatch('getAwaitHandleNum')
		},
		async getSchoolList({ state }) {
			let schoolList = await $H.get("/admin/fwUser/schoolList")
			state.schoolList = schoolList
			if(state.userInfo.type == 10){
				let nowSchool = schoolList.find(v => v.agentid==state.userInfo.studentid)
				state.nowSchoolId = nowSchool.id
				sessionStorage.setItem('nowSchoolId', state.nowSchoolId)
			}
		},
		async getAwaitHandleNum({ state,commit }) {
			let {awaitFeedbackNum,awaitStudentAuthNum1,
			awaitStudentAuthNum2, awaitTravelRefundOrderNum,
			awaitDriverCustomer,awaitSchoolCardNum,awaitGoodsOrderNum} = await $H.get("/admin/fwUser/awaitHandleTipNum")
			state.awaitFeedbackNum = awaitFeedbackNum
			state.awaitStudentAuthNum1 = awaitStudentAuthNum1
			state.awaitStudentAuthNum2 = awaitStudentAuthNum2
			state.awaitTravelRefundOrderNum = awaitTravelRefundOrderNum
			state.awaitDriverCustomer = awaitDriverCustomer
			state.awaitSchoolCardNum = awaitSchoolCardNum
			state.awaitGoodsOrderNum = awaitGoodsOrderNum
			let schoolMenu = state.menuList.find(v => v.id==185)
			if(schoolMenu){
				schoolMenu.badgeVal = awaitStudentAuthNum1+awaitStudentAuthNum2
				let studentMenu = schoolMenu.children.find(v => v.id==160)
				if(studentMenu) studentMenu.badgeVal = awaitStudentAuthNum1+awaitStudentAuthNum2
			}
			let systemDataMenu = state.menuList.find(v => v.id==262)
			if(systemDataMenu){
				systemDataMenu.badgeVal = awaitFeedbackNum
				let feedbackMenu = systemDataMenu.children.find(v => v.id==263)
				if(feedbackMenu) feedbackMenu.badgeVal = awaitFeedbackNum
			}
			let travelMenu = state.menuList.find(v => v.id==271)
			if(travelMenu){
				travelMenu.badgeVal = awaitTravelRefundOrderNum
				let travelOrderMenu = travelMenu.children.find(v => v.id==279)
				if(travelOrderMenu) travelOrderMenu.badgeVal = awaitTravelRefundOrderNum
			}
			
			let driverSchoolMenu = state.menuList.find(v => v.id==290)
			if(driverSchoolMenu){
				driverSchoolMenu.badgeVal = awaitDriverCustomer
				let driverCustomerMenu = driverSchoolMenu.children.find(v => v.id==297)
				if(driverCustomerMenu) driverCustomerMenu.badgeVal = awaitDriverCustomer
			}

			let schoolCardMenu = state.menuList.find(v => v.id==346)
			if(schoolCardMenu){
				schoolCardMenu.badgeVal = awaitSchoolCardNum
				let schoolCardMenuChildren = schoolCardMenu.children.find(v => v.id==331)
				if(schoolCardMenuChildren) schoolCardMenuChildren.badgeVal = awaitSchoolCardNum
			}

			let goodsOrderCardMenu = state.menuList.find(v => v.id==353)
			if(goodsOrderCardMenu){
				goodsOrderCardMenu.badgeVal = awaitGoodsOrderNum
				let goodsOrderMenuChildren = goodsOrderCardMenu.children.find(v => v.id==361)
				if(goodsOrderMenuChildren) goodsOrderMenuChildren.badgeVal = awaitGoodsOrderNum
			}
			commit("initLeftMenu")
		},
	}
}


function selectNowActive(menuList,path){
	let index = menuList.findIndex(v => {
		if(v.children && v.children.length > 0){
			return selectNowActive(v.children, path) > -1
		}
		return v.path == path
	})
	return index
}
